import { $, $$, isTablet, sliderConfig } from '@utils';
import Swiper from 'swiper';
import { Navigation, Scrollbar, A11y, FreeMode } from 'swiper/modules';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-traction-calculator]')) return;

  const slidersArray = [];

  addEventListeners(slidersArray);
  if (isTablet.matches) buildSlider(slidersArray, isTablet.matches);
}

function addEventListeners(slidersArray) {
  isTablet.addEventListener('change', () => initSlider(slidersArray));

  // calculate data on init and on input change
  $$('[data-au-traction-calculator-inputs] input').forEach((input) => {
    input.addEventListener('input', (e) => {
      calculateData(e);
    });

    input.addEventListener('blur', (e) => {
      calculateData(e);
    });
  });
  calculateData();

  // datalayer
  $$('[data-au-traction-calculator-table-link]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      dataLayerTableLink(e);
    });
  });
}

function buildSlider(slidersArray) {
  $$('[data-au-traction-calculator-slider]').forEach((slider) => {
    const newsSlider = new Swiper(slider, {
      modules: [Navigation, Scrollbar, A11y, FreeMode],
      ...sliderConfig,
    });

    slidersArray.push(newsSlider);
  });
}

function initSlider(slidersArray) {
  if (isTablet.matches) {
    buildSlider(slidersArray);
    return;
  }

  slidersArray.forEach((slider) => slider.destroy());
}

function calculateData(e) {
  if (e) e.preventDefault();

  const numberCars = parseInt($('#vehicles-number').value, 10),
    litersAvg = parseFloat($('#consumption').value),
    kmAvg = parseFloat($('#annual-km').value),
    priceFuel = parseFloat($('#fuel-price').value),
    emissions = 2.6510016;

  $$('[data-au-traction-calculator-slide]').forEach((slide, index) => {
    const values = [1.31, 0.9, 1.29, 1.27, 1.08];
    const constNumber = values[index];
    calculateOfferProduct(numberCars, kmAvg, litersAvg, priceFuel, emissions, constNumber, index);
  });
}

function calculateValues(economyFactor, cars, kms, liters, price, emissions) {
  var estimated = liters - liters * (economyFactor / 100),
    increment = ((estimated - liters) * 100) / liters,
    a = cars * kms * (liters / 100),
    b = cars * kms * (estimated / 100),
    co2 = (a - b) * emissions,
    savings = cars * kms * (liters / 100) * price - cars * kms * (estimated / 100) * price;

  return {
    savings,
    estimated,
    increment,
    co2,
  };
}

function calculateOfferProduct(cars, kms, liters, price, emissions, constNumber, indexNumber) {
  var result = calculateValues(constNumber, cars, kms, liters, price, emissions);

  // prettier-ignore
  $$('[data-au-traction-calculator-slide]')[indexNumber].querySelector(
    '[data-au-traction-calculator-annual-saving]',
  ).innerHTML = !isNaN(result.savings)
    ? result.savings
      .toFixed()
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    : '- ';

  // prettier-ignore
  $$('[data-au-traction-calculator-slide]')[indexNumber].querySelector(
    '[data-au-traction-calculator-co-reduction]',
  ).innerHTML = !isNaN(result.co2)
    ? result.co2
      .toFixed()
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    : '- ';

  $$('[data-au-traction-calculator-slide]')[indexNumber].querySelector(
    '[data-au-traction-calculator-estimated]',
  ).innerHTML = !isNaN(result.estimated) ? result.estimated.toFixed(2).replace('.', ',') : '- ';

  $$('[data-au-traction-calculator-slide]')[indexNumber].querySelector(
    '[data-au-traction-calculator-increment]',
  ).innerHTML = !isNaN(result.increment) ? `${result.increment.toFixed(2).replace('.', ',')}%` : '- ';
}

function dataLayerTableLink(e) {
  const tableTitle = $('[data-au-traction-calculator-table-title]').textContent;
  const clickText = e.currentTarget
    .closest('[data-au-traction-calculator-slide]')
    .querySelector('[data-au-traction-calculator-product-name]').textContent;
  const item_id = `${removeAccentMarkAndUppercase(tableTitle)}_${removeAccentMarkAndUppercase(clickText)}`;

  window.dataLayer.push({
    event: 'navigation',
    content_type: 'clickCard',
    item_id,
  });
}

export default { init };
